var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"size-28 weight-500 text-center",style:(_vm.msgStyle),domProps:{"innerHTML":_vm._s(_vm.showMsg)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }